import axios from "axios"

const paramsSerializer = (params) => {
  const Qs = require("qs")
  return Qs.stringify(params, { encode: false })
}

export const findPersons = (headers, params) => {
  return axios.get(`${process.env.REACT_APP_MANAGEMENT_API_URL}/persons`, {
    headers,
    params,
    paramsSerializer
  })
}

export const findPersonInfo = (headers) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/myself`,
    {
      headers
    }
  )
}

export const findPersonById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}`,
    {
      headers
    }
  )
}

export const findPersonByCode = (headers, code) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/code/${code}`,
    {
      headers
    }
  )
}

export const findPersonByEmail = (headers, email) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${email}/find`,
    {
      headers
    }
  )
}

export const createPerson = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/create/customer`,
    data,
    {
      headers
    }
  )
}

export const uploadAvatar = (headers, id, formData) => {
  return axios.put(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}/avatar`,
    formData,
    {
      headers
    }
  )
}

export const updatePerson = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}`,
    data,
    {
      headers
    }
  )
}

export const deletePerson = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}`,
    {
      headers
    }
  )
}

export const deletePersons = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons?id=${ids.join()}`,
    {
      headers
    }
  )
}

export const changePwd = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/change-pwd`,
    data,
    {
      headers
    }
  )
}

export const searchPersons = (headers, params) => {
  return axios.get(`${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/search`, {
    headers,
    params,
    paramsSerializer
  })
}

export const lockPerson = (headers, id, data) => {
  return axios.post(`${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/lock-or-unlock-person/${id}`,
    data,
    {
      headers
    })
}

export const getPersonByUserId = (headers, userId) => {
  return axios.get(`${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/find-by-user-id/${userId}`,
    {
      headers
    })
}

export const getCertificatesPerson = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/certificate/${id}/person`,
    {
      headers
    }
  )
}

export const deleteAndReactiveAccount = (headers, email) => {
  return axios.delete(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/delete-by-person-email-and-reactive-account/${email}`,
    {
      headers
    }
  )
}

export const deleteDuplicateAndReactiveAccount = (headers, subOrEmailOrPhone, personIdSelected) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/delete-duplicate-and-reactive-account?subOrEmailOrPhone=${subOrEmailOrPhone}&personIdSelected=${personIdSelected}`,
    {},
    {
      headers
    }
  )
}

export const findClientsById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/client/${id}/client-per`,
    {
      headers
    },
    { useCache: false }
  )
}

export const findClientsOrgById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/client/${id}/client-org`,
    {
      headers
    },
    { useCache: false }
  )
}

export const findDivices = (headers, sub) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${sub}/find-device-smart-otp/admin`,
    {
      headers
    }
  )
}

export const deleteDevices = (headers, id, sub, params) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/${id}/delete-device-smart-otp/admin?sub=${sub}&${params}`,
    {},
    {
      headers
    }
  )
}

export const findPersonBySub = (headers, sub) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/find-by-sub/${sub}`,
    {
      headers
    }
  )
}

export const getLoginInformationByPersonId = (headers, personId) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/get-login-information-by-person-id?personId=${personId}`,
    {
      headers
    }
  )
}

export const resetPasswordAmin = (headers, body) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/persons/reset-password-admin`,
    body,
    {
      headers
    }
  )
}

